
import FreebieCounter from './FreebieCounter.vue';
import TacoRating from './TacoRating.vue';

export default {
  name: 'DealRating',
  components: {
    FreebieCounter,
    TacoRating,
  },
  props: {
    deal: {
      type: Object,
      required: true,
    },
    isDealCard: {
      type: Boolean,
    },
  },
};
